<template>
  <mk-drawer
    class="preview"
    :visible.sync="show"
    :modal-append-to-body="false"
    :append-to-body="false"
    size="420px"
    hide-header
    :before-close="cancel"
  >
    <div class="content">
      <div class="close">
        <mk-iconfont
          class="icon"
          icon-class="guanbi"
          @click.native="cancel"
        ></mk-iconfont>
      </div>

      <mk-image
        :src="dialogData && dialogData.cover"
        fit="cover"
        class="cover-img"
        alt="cover"
      />
      <div class="tit">
        <div class="tit-title">
          标题
        </div>
        <span>{{ dialogData && dialogData.title }}</span>
      </div>
    </div>
    <div
      class="preview-content"
      @click.self="cancel"
    >
      <div class="preview-content-c">
        <img
          class="phone-img"
          src="@/assets/images/phone.png"
          alt="phone"
          width="340"
        >
        <iframe
          :src="linkUrl + '&iframeData=yes&view=yes'"
          class="preview-iframe"
          frameborder="0"
          @load="iframeOnLoad"
        />
      </div>
    </div>
  </mk-drawer>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      linkUrl: ''
    }
  },
  created () {
    const { linkUrl } = this.util.createH5Url({
      _id: 'iframe',
      sourceType: 1
    }, 'case', this.$projectScene, true)
    this.linkUrl = linkUrl
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    iframeOnLoad () {
      this.loading = false
      this.previewIframeDom = document.querySelector('.preview-iframe')
      this.postMessage({
        title: this.dialogData.title,
        cover: this.dialogData.cover,
        context: this.dialogData.context,
        sourceType: 1
      })
    },
    postMessage (postData) {
      let data = {
        _id: 'iframe',
        sourceType: 1
      }

      this.previewIframeDom.contentWindow.postMessage({
        postType: 'data',
        postData: postData
      }, this.linkUrl)
    }
  }
}
</script>
<style lang="scss" scoped>
.preview {
  .content {
    width: calc(100% - 60px);
    margin: 0 auto;

    .close {
      display: flex;
      justify-content: flex-end;

      .icon {
        font-size: 20px;
        color: #000;
        margin-top: 20px;
      }
    }

    .cover-img {
      display: block;
      width: 160px;
      height: 160px;
      margin-top: 40px;
    }

    .tit {
      margin-top: 20px;

      .title {
        font-size: 14px;
        color: #000;
      }

      span {
        font-size: 13px;
        color: #595959;
      }
    }
  }

  .preview-content {
    width: calc(100vw - 420px);
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;

    .preview-content-c {
      width: 340px;
      height: 580px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      iframe {
        width: 300px;
        height: 504px;
        overflow-x: hidden;
        overflow-y: auto;
        position: absolute;
        top: 36px;
        left: 20px;
      }
    }
  }
}
</style>
